import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import KenoContent from "./components/KenoContent";

class KenoApp extends Component {
  render() {
    return (
      <>
        <KenoContent />
        <ToastContainer />
      </>
    );
  }
}

export default KenoApp;
